export const TIPO_LINEA_ASIENTO = {
  HABER: 0,
  DEBE: 1,
} as const

export type TipoLineaAsientoType =
  (typeof TIPO_LINEA_ASIENTO)[keyof typeof TIPO_LINEA_ASIENTO]
